import { AssetFieldsFragment } from "@src/generated/graphql";
import Typography from "./Typography";
import { highlightBracketedText } from "src/utils/utils";
import DynamicLink from "./DynamicLink";
import { FaArrowRightLong } from "react-icons/fa6";
import DynamicMedia from "./DynamicMedia";

type CardProps = {
  item: {
    featureCardTitle: string;
    featureCardDescription: string;
    featureCardImage: { url: string ,title:string};
    featureCardLinkText: string;
    featureCardLinkUrl: string;
    card1Title: string;
    card2Title: string;
    card3Title: string;
    card4Title: string;
    card1Description: string;
    card2Description: string;
    card3Description: string;
    card4Description: string;
    card1Image: { url: string };
    card2Image: { url: string };
    card3Image: { url: string };
    card4Image: { url: string };
  };
  typographyClassName?: string;
  tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  index?: number;
};

const Card = ({
  item,
  typographyClassName,
  tag = "h6",
  index,
}: CardProps) => {
  const isImageRight = index && (index + 1) % 2 === 0;
  const cards = [
    { title: item.card1Title, description: item.card1Description, image: item.card1Image },
    { title: item.card2Title, description: item.card2Description, image: item.card2Image },
    { title: item.card3Title, description: item.card3Description, image: item.card3Image },
    { title: item.card4Title, description: item.card4Description, image: item.card4Image }
  ].filter(card => card.title && card.description && card.image);



  return (
    <div className="feature-card">
      <div className={`feature-card__header ${isImageRight ? "feature-card__header--reverse" : ""}`}>
        <div className="feature-card__image">
        <DynamicMedia
            src={item.featureCardImage?.url}
            alt={item?.featureCardImage.title ?? ""}
            ariaLabel={item?.featureCardImage.title  ?? ""}
            lottieProps={{
              loop:true
            }}
          />
        </div>
        <div className="feature-card__header-content">
          <span
            className="feature-card__title-main"
            dangerouslySetInnerHTML={{
              __html: highlightBracketedText(item.featureCardTitle ?? "", "regular"),
            }}
          />
          {item.featureCardDescription && (
            <p className="feature-card__description-main">{item.featureCardDescription}</p>
          )}
          <div>
            <DynamicLink url={item.featureCardLinkUrl} className="btn-default-bdr">
              <span>{item.featureCardLinkText}</span>
              <FaArrowRightLong className="btn-icon" />
            </DynamicLink>
          </div>
        </div>
      </div>

      <hr className="feature-card__divider" />

      <div className="feature-card__grid">
        {cards.map((card, idx) => (
          <div key={idx} className="feature-card__item">
            <div className="feature-card__icon">
              <img src={card.image?.url} alt="icon" />
            </div>
            <div className="feature-card__content">
              <Typography
                tag={tag}
                className={`feature-card__title ${typographyClassName || ""}`}
              >
                {card.title}
              </Typography>
              <p className="feature-card__description">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Card;